import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethod } from '@vision/ui/enums';
import { HttpExtraOptions } from '@vision/ui/interfaces';
import { axiosBaseQuery } from '../base.service';

export interface TicketManagerApiRequest {
  data?: unknown;
  extraOptions?: HttpExtraOptions;
  method: HttpMethod;
  url: string;
}

export const TicketManagerApi = createApi({
  reducerPath: 'TicketManagerService',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'TicketManagerProjectList',
    'TicketManagerProjectPools',
    'TicketManagerPoolMembers',
    'TicketManagerTeamMembers',
    'TicketManagerProjectQueues',
    'TicketManagerProjectTeams',
    'TicketManagerProjectRootCauseGroups',
    'TicketManagerProjectRootCauses',
    'TicketManagerRootCauseGroupRootCauses',
    'TicketManagerPoolTickets',
    'TicketManagerQueueTickets',
    'TicketManagerTicketDetail',
    'TicketManagerTicketActionLogs',
    'TicketManagerTicketAssignableUsers',
    'TicketManagerTicketRootCauses',
    'TicketManagerTicketAvailableStatuses',
    'TicketManagerTicketStatuses',
    'TicketManagerTicketComments',
    'TicketManagerTicketConversations',
    'TicketManagerTicketConversationMessages',
    'TicketManagerStatusTransitions',
  ],
  endpoints: () => ({}),
});
